import { AUTOPAY_SETTINGS_DEFAULTS, type AutopaySettingsValues } from '../components/AutopaySettings';

type AutopaySettingsRecord = {
  enabled?: boolean | null;
  paymentType?: string | null;
  daysBeforePayment?: number | null;
  plaidAccountId?: string | null;
};

export const toAutopayValues = (settings: AutopaySettingsRecord | null | undefined): AutopaySettingsValues | null =>
  settings
    ? {
        enabled: settings.enabled ?? AUTOPAY_SETTINGS_DEFAULTS.enabled,
        paymentType: settings.paymentType ?? AUTOPAY_SETTINGS_DEFAULTS.paymentType,
        daysBeforePayment: settings.daysBeforePayment ?? AUTOPAY_SETTINGS_DEFAULTS.daysBeforePayment,
        plaidAccountId: settings.plaidAccountId ?? AUTOPAY_SETTINGS_DEFAULTS.plaidAccountId,
      }
    : null;
